// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3LYo6","buttons":"Footer_buttons__3NeJg"};